var _style, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ey4Ka1sCD3O1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n#ey4Ka1sCD3O3_to {animation: ey4Ka1sCD3O3_to__to 1900ms linear infinite normal forwards}@keyframes ey4Ka1sCD3O3_to__to { 0% {transform: translate(25.0576px,14.887369px)} 21.052632% {transform: translate(25.0576px,14.887369px);animation-timing-function: cubic-bezier(0.25,1,0.25,1)} 73.684211% {transform: translate(25px,28.003214px)} 100% {transform: translate(25px,28.003214px)}} #ey4Ka1sCD3O3_ts {animation: ey4Ka1sCD3O3_ts__ts 1900ms linear infinite normal forwards}@keyframes ey4Ka1sCD3O3_ts__ts { 0% {transform: scale(1.4997,1.499701)} 78.947368% {transform: scale(1.976154,1.836351)} 100% {transform: scale(1.692051,1.64545)}} #ey4Ka1sCD3O3 {animation: ey4Ka1sCD3O3_c_o 1900ms linear infinite normal forwards}@keyframes ey4Ka1sCD3O3_c_o { 0% {opacity: 1} 73.684211% {opacity: 1} 89.473684% {opacity: 0} 100% {opacity: 0}} #ey4Ka1sCD3O4_to {animation: ey4Ka1sCD3O4_to__to 1900ms linear infinite normal forwards}@keyframes ey4Ka1sCD3O4_to__to { 0% {transform: translate(24.982192px,14.88737px)} 21.052632% {transform: translate(24.982192px,14.88737px)} 73.684211% {transform: translate(24.98219px,28.003214px)} 100% {transform: translate(24.98219px,28.003214px)}} #ey4Ka1sCD3O4 {animation: ey4Ka1sCD3O4_c_o 1900ms linear infinite normal forwards}@keyframes ey4Ka1sCD3O4_c_o { 0% {opacity: 0} 73.684211% {opacity: 0.25} 89.473684% {opacity: 0} 100% {opacity: 0}} #ey4Ka1sCD3O5_to {animation: ey4Ka1sCD3O5_to__to 1900ms linear infinite normal forwards}@keyframes ey4Ka1sCD3O5_to__to { 0% {transform: translate(24.982192px,14.88737px)} 21.052632% {transform: translate(24.982192px,14.88737px)} 47.368421% {transform: translate(25.0576px,17.073343px)} 73.684211% {transform: translate(24.98219px,28.003214px)} 100% {transform: translate(24.98219px,28.003214px)}} #ey4Ka1sCD3O5_ts {animation: ey4Ka1sCD3O5_ts__ts 1900ms linear infinite normal forwards}@keyframes ey4Ka1sCD3O5_ts__ts { 0% {transform: scale(1.549105,1.549097)} 47.368421% {transform: scale(1.549105,1.549097)} 63.157895% {transform: scale(1.541046,2.480753)} 73.684211% {transform: scale(1.560774,1.549097)} 78.947368% {transform: scale(2.467469,2.275742)} 100% {transform: scale(2.467469,2.275742)}} #ey4Ka1sCD3O5 {animation: ey4Ka1sCD3O5_c_o 1900ms linear infinite normal forwards}@keyframes ey4Ka1sCD3O5_c_o { 0% {opacity: 0} 73.684211% {opacity: 0.25} 89.473684% {opacity: 0} 100% {opacity: 0}}\r\n>")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.763839 0 0 0.678814 5.917628 2.888043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ey4Ka1sCD3O3_to",
    transform: "translate(25.0576,14.887369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ey4Ka1sCD3O3_ts",
    transform: "scale(1.4997,1.499701)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "ey4Ka1sCD3O3",
    rx: 1.526322,
    ry: 2.822256,
    transform: "translate(0,0)",
    fill: "#fff",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ey4Ka1sCD3O4_to",
    transform: "translate(24.982192,14.88737)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "ey4Ka1sCD3O4",
    rx: 1.526322,
    ry: 2.822256,
    transform: "scale(2.449015,2.275742) translate(0,0)",
    opacity: 0,
    fill: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "ey4Ka1sCD3O5_to",
    transform: "translate(24.982192,14.88737)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ey4Ka1sCD3O5_ts",
    transform: "scale(1.549105,1.549097)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "ey4Ka1sCD3O5",
    rx: 1.526322,
    ry: 2.822256,
    transform: "translate(0,0)",
    opacity: 0,
    fill: "#fff",
    strokeWidth: 0.5
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0576,45.09849c-7.68205,0-11.49061-7.85609-11.49061-20.0409v.00001c0-6.47267.88535-13.96474,2.24628-17.282C16.73482,5.52932,21.39872,4.722957,25,4.722957m0,0c3.60128,0,8.38038.806363,9.30193,3.052653c1.36093,3.31725,2.24628,10.80933,2.24628,17.282c0,12.18481-3.80856,20.0409-11.49061,20.0409v-.00001",
    transform: "translate(0 0.000001)",
    fill: "none",
    stroke: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouse);
export default __webpack_public_path__ + "static/media/mouse.8d216fc5b22f1d804d2ca94dd2b1d66d.svg";
export { ForwardRef as ReactComponent };